









































import liquidationType from '@/store/types/liquidations';
import DatesFormat from '@/util/classes/datesFormat';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { LiquidationParams } from '@/store/interfaces/liquidations';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
const formatDate = new DatesFormat();

export default Vue.extend({
  name: 'LiquidationsHome',
  data: () => ({
    viewDetails: false,
    propsToSearch: ['business_name', 'tradename'] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'id',
        label: 'Codigo',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'company_name',
        label: '', // assigned in created function
        minWidth: 380,
        sortable: true,
        formatter: (row: LiquidationParams) => {
          return `${row.company.business_name}`;
        },
      },
      {
        prop: 'created_at',
        label: 'Fecha de generacion',
        minWidth: 180,
        sortable: true,
      },
      {
        prop: 'liquidation_period',
        label: 'Fecha a liquidar',
        formatter: (row: LiquidationParams) => {
          return `${formatDate.formatYear(row.period_from)} / ${formatDate.formatYear(row.period_to)}`;
        },
        minWidth: 180,
        sortable: true,
      },
      {
        prop: 'subtotal_cents',
        label: 'Volumen total de transacciones',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'transactions_count',
        label: 'Cantidad de transacciones',
        minWidth: 220,
        sortable: true,
      },
      {
        prop: 'subtotal_without_taxes_cents',
        label: 'Monto comisionable',
        minWidth: 180,
        sortable: true,
      },
      {
        prop: 'total_cents',
        label: 'Monto a liquidar neto',
        minWidth: 190,
        sortable: true,
      },
      {
        prop: 'stated_taxes_cents',
        label: 'Total IVA',
        minWidth: 100,
        sortable: true,
      }
    ] as tTableColumns,
    rowSelected: undefined,
    showevent: false,
  }),
  computed: {
    ...mapGetters({
      getLiquidationList: `liquidationModule/${liquidationType.getters.GET_LIQUIDATIONS}`,
    }),
  },
  created() {
    this.$data.tableColumns[1].label = `Nombre de la ${this.$t('menu.company.singular.informal').toString()}`;
  },
  mounted() {
    this.liquidationList();
  },
  methods: {
    ...mapActions({
      liquidationList: `liquidationModule/${liquidationType.actions.LIQUIDATION_LIST}`,
      singleLiquidation: `liquidationModule/${liquidationType.actions.SINGLE_LIQUIDATION}`,
    }),
    viewDetailsAction() {
      this.$router.push({
        name: 'liquidation-detail',
        params: {
          liquidation_id: this.$data.rowSelected.id,
        },
      });
    },
    rowselect(row: {id: string}) {
      this.$data.rowSelected = row;
      if (this.singleLiquidation) {
        this.singleLiquidation(row.id);
      }
    },

  },
});
